
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 96 81","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_1_1_"}},[_c('g',{attrs:{"id":"cog"}},[_c('path',{attrs:{"fill":"#2f84b2","d":"M28 64.6l-5.8-1.4-9.1 2.4V53.3l44.3.1v12.2l-9.1-2.4-5.8 1.4-3.4 5.5h-7.7z"}}),_c('path',{staticClass:"st1",attrs:{"fill":"#25759B","d":"M31.4 60.9v9.2L28 64.6v-9.2zM13.1 56.6v9l-5.5-3.2v-9L0 52v-9.2l11.1 1.1zM7.6 36.8v-9l7.3 8.1z"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#3299CC","d":"M58.3 43.8l12.1-1V52l-7.5 1.4v9l-5.5 3.2v-9zM62.5 36.7l-6.9-.4 7-8.6z"}}),_c('path',{attrs:{"fill":"#3da6d8","d":"M48.3 27.1l-5.8-1.3-3.4-5.5h-7.9l-3.3 5.5-5.8 1.3-9.1-2.5-5.5 3.2 4.4 5.2-2.3 3.4-9.5 2V43l9.5 2v6.2l-2 2.3 5.5 3.2 9.1-2.5 5.8 1.3 3.4 5.5h7.9l3.4-5.5 5.8-1.3h.1l9 2.4 5.5-3.2-4.4-5.2 2.3-3.4 9.5-2v-4.6l-9.5-2-2.3-3.4 4-5.4-5.4-3.1-9 2.8z"}}),_c('path',{staticClass:"st1",attrs:{"fill":"#25759B","d":"M41.8 44.4c-.5.3-1.1.5-1.6.7-3.1 1.2-7 1.2-10.1 0-.5-.3-1.1-.4-1.6-.7-3.6-2.1-3.6-5.5 0-7.6s9.7-2.1 13.3 0c3.7 2.1 3.7 5.5 0 7.6z"}})])]),_c('g',{attrs:{"id":"arrow"}},[_c('path',{staticClass:"st4",attrs:{"fill":"#D33F3E","d":"M50.1 48.5l-4.5-2.6 45.6-26.3 4.5 2.6z"}}),_c('path',{attrs:{"fill":"#c03c3b","d":"M61.5 41.9L57 39.3V13.2l4.4 2.6z"}}),_c('path',{staticClass:"st4",attrs:{"fill":"#D33F3E","d":"M61.4 15.8L57 13.2 79.7 0l4.5 2.6z"}}),_c('path',{attrs:{"fill":"#ed7467","d":"M84.2 2.6L61.4 15.8l.1 26.2-11.4 6.5L73 61.6l22.7-39.4-11.4 6.6-.1-26.2"}}),_c('animateMotion',{attrs:{"path":"M 0 0 V 15 Z","calcMode":"spline","keySplines":"0.42 0 0.58 1","keyTimes":"0;1","values":"1;0.9","dur":"0.8s","repeatCount":"indefinite"}})])])
          )
        }
      }
    